import { createFileRoute } from "@tanstack/react-router";
import { SiteCompliancePage, siteComplianceHead } from "@/pages/SiteCompliancePage";

export const Route = createFileRoute("/sitecompliance")({
  head: () => siteComplianceHead("da"),
  component: () => <SiteCompliancePage locale="da" />,
});